import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {KeycloakService} from "keycloak-angular";
import {JwtService} from "../services/jwt.service";
import {jwtDecode} from "jwt-decode";
import {KeycloakJwtModel} from "../models/keycloak-jwt.model";
import { faro } from '@grafana/faro-web-sdk';

export const keycloakGuard: CanActivateFn = async (route, state) => {
  const keycloakService: KeycloakService = inject(KeycloakService);
  const router: Router = inject(Router);
  const jwtTokenService: JwtService = inject(JwtService);
  const isLoggedIn = keycloakService.isLoggedIn();
  const token = await keycloakService.getToken();

  let decoded: KeycloakJwtModel = jwtDecode(token);
  let isExpired: boolean = (decoded.exp <= Math.floor(Date.now()/1000));
  let timeStamp = Date.now().toLocaleString('it-IT');
  if (!isLoggedIn && isExpired) {
    if (faro.api) {
      faro.api.pushEvent('Token Scaduto O Vuoto, Reindirizzamento',{
        token:token,
        timestamp:timeStamp
      });
    }
    await router.navigate(['/login'])

  }
  if (faro.api) {
    faro.api.pushEvent('Guard Passata',{
      token:token,
      timestamp:timeStamp
    });
  }
  await jwtTokenService.set(token);
  return isLoggedIn;
};
